import { createExperimentsDescriptor } from '@johnlewispartnership/wtr-website-decisioner-client/express';

export const MONETATE_DEFAULT_VARIANT = 'default';

export const EOS_NEW_HEADER = createExperimentsDescriptor('EoS_newHeader', {
  default: MONETATE_DEFAULT_VARIANT,
  showNewHeader: 'showNewHeader',
});

export const monetateExperiments = [EOS_NEW_HEADER];
